
const config = {
  APIUrl: 'https://apimgmt-prod.gmhba.com.au',
  Theme: 'GMHBA',
  SiteUrl: 'https://photoclaim.gmhba.com.au',
  PublicSiteUrl: 'https://www.gmhba.com.au',
  MemberAreaSiteUrl: 'https://member.gmhba.com.au',
  GoogleTagManagerId: 'GTM-WFDS7F',
  TrackerClientDSNKey: 'https://7b268906d75b4554af64e4c4ede16486@sentry.io/1179485'
}

export default config;



//////////////////
// WEBPACK FOOTER
// ./app.config.js
// module id = 585
// module chunks = 1